import React, { lazy } from 'react';
import { useLanguage } from '../hooks/useLanguage';
export function ImageBanner() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white" data-id="element-101">
      <div className="w-full h-full overflow-hidden" data-id="element-102">
        <img src="https://cdn.magicpatterns.com/uploads/5kmKCZhZUCYact5iygtaBe/Kratom_Header_1920_x_585.webp" alt="Premium Kratom leaves, powder, and capsules on wooden background" className="w-full h-auto object-cover max-h-[600px]" loading="lazy" data-id="element-103" />
      </div>
    </section>;
}